import arrowRightRounded from './ArrowRounded.vue'
import folder from './Folder.vue'
import frFlag from './FRFlag.vue'
import geodis from './Geodis.vue'
import geodisBanner from './GeodisBanner.vue'
import lineSCO from './LineSCO.vue'
import usaFlag from './USAFlag.vue'
import vectorLines from './VectorLines.vue'
import policy from './Policy.vue'

export const customPropsIcons = {
  arrowRightRoundedFilled: {
    component: arrowRightRounded,
    props: {
      fill: true,
    },
  },
  arrowLeftRounded: {
    component: arrowRightRounded,
    props: {
      left: true,
    },
  },
  arrowLeftRoundedFilled: {
    component: arrowRightRounded,
    props: {
      fill: true,
      left: true,
    },
  },
};

export default {
  arrowRightRounded,
  folder,
  frFlag,
  geodis,
  geodisBanner,
  lineSCO,
  usaFlag,
  vectorLines,
  policy,
};
